import {
  UPLOAD_DOCUMENT_MANAGER,
  SET_UPLOADED_DOCUMENT,
  RESET_UPLOAD_DOCUMENT_STORE,
  SET_DOCUMENT_ID,
} from 'containers/UploadDocumentsManager/constants';
export const uploadDocument = (uploadFile: any, failedCallBack: Function) => ({
  type: UPLOAD_DOCUMENT_MANAGER,
  uploadFile,
  failedCallBack,
});
export const setUploadDocument = (uploadedDocument: any) => ({
  type: SET_UPLOADED_DOCUMENT,
  uploadedDocument,
});

export const setDocumentId = (documentId: string) => ({
  type: SET_DOCUMENT_ID,
  documentId,
});

export const resetUploadDocumentStore = () => ({
  type: RESET_UPLOAD_DOCUMENT_STORE,
});
